import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { TimeoutTimer } from '../../../common/async.js';
import { Disposable } from '../../../common/lifecycle.js';
export var ScrollbarVisibilityController = /*#__PURE__*/function (_Disposable) {
  _inherits(ScrollbarVisibilityController, _Disposable);

  var _super = _createSuper(ScrollbarVisibilityController);

  function ScrollbarVisibilityController(visibility, visibleClassName, invisibleClassName) {
    var _this;

    _classCallCheck(this, ScrollbarVisibilityController);

    _this = _super.call(this);
    _this._visibility = visibility;
    _this._visibleClassName = visibleClassName;
    _this._invisibleClassName = invisibleClassName;
    _this._domNode = null;
    _this._isVisible = false;
    _this._isNeeded = false;
    _this._shouldBeVisible = false;
    _this._revealTimer = _this._register(new TimeoutTimer());
    return _this;
  } // ----------------- Hide / Reveal


  _createClass(ScrollbarVisibilityController, [{
    key: "applyVisibilitySetting",
    value: function applyVisibilitySetting(shouldBeVisible) {
      if (this._visibility === 2
      /* Hidden */
      ) {
        return false;
      }

      if (this._visibility === 3
      /* Visible */
      ) {
        return true;
      }

      return shouldBeVisible;
    }
  }, {
    key: "setShouldBeVisible",
    value: function setShouldBeVisible(rawShouldBeVisible) {
      var shouldBeVisible = this.applyVisibilitySetting(rawShouldBeVisible);

      if (this._shouldBeVisible !== shouldBeVisible) {
        this._shouldBeVisible = shouldBeVisible;
        this.ensureVisibility();
      }
    }
  }, {
    key: "setIsNeeded",
    value: function setIsNeeded(isNeeded) {
      if (this._isNeeded !== isNeeded) {
        this._isNeeded = isNeeded;
        this.ensureVisibility();
      }
    }
  }, {
    key: "setDomNode",
    value: function setDomNode(domNode) {
      this._domNode = domNode;

      this._domNode.setClassName(this._invisibleClassName); // Now that the flags & the dom node are in a consistent state, ensure the Hidden/Visible configuration


      this.setShouldBeVisible(false);
    }
  }, {
    key: "ensureVisibility",
    value: function ensureVisibility() {
      if (!this._isNeeded) {
        // Nothing to be rendered
        this._hide(false);

        return;
      }

      if (this._shouldBeVisible) {
        this._reveal();
      } else {
        this._hide(true);
      }
    }
  }, {
    key: "_reveal",
    value: function _reveal() {
      var _this2 = this;

      if (this._isVisible) {
        return;
      }

      this._isVisible = true; // The CSS animation doesn't play otherwise

      this._revealTimer.setIfNotSet(function () {
        if (_this2._domNode) {
          _this2._domNode.setClassName(_this2._visibleClassName);
        }
      }, 0);
    }
  }, {
    key: "_hide",
    value: function _hide(withFadeAway) {
      this._revealTimer.cancel();

      if (!this._isVisible) {
        return;
      }

      this._isVisible = false;

      if (this._domNode) {
        this._domNode.setClassName(this._invisibleClassName + (withFadeAway ? ' fade' : ''));
      }
    }
  }]);

  return ScrollbarVisibilityController;
}(Disposable);